// extracted by mini-css-extract-plugin
module.exports = {"contents":"Ez","sectionHeading":"Fz"};